<div>
    <form [formGroup]="searchForm">
        <input class="searchValue" type="search" formControlName="searchValue" placeholder="Recherche">
        <img class="grey-filter search-icon cursor" [src]="searchForm.get('searchValue')?.value != '' ? '/assets/icons/picto-croix-rouge.png' : '/assets/icons/search.png' " height="15" alt="rechercher" (click)="clearSearchBar()">
    </form>
</div>
